import { DEFAULT_CASES, DEFAULT_OPTIONS } from "./data.js";

const KEY = "funeral-media-case-system:v2";

export function loadState() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // Ignore invalid local cache and fall back to seed data.
  }
  return { cases: DEFAULT_CASES, options: DEFAULT_OPTIONS };
}

export function saveState(next) {
  localStorage.setItem(KEY, JSON.stringify(next));
}
